import { render } from "./JoinPublicationExistingUser.vue.js?vue&type=template&id=1b36ddf8!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=template&id=1b36ddf8"
import script from "./JoinPublicationExistingUser.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=script&lang=js"
export * from "./JoinPublicationExistingUser.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationExistingUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b36ddf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b36ddf8', __exports__)) {
    api.reload('1b36ddf8', __exports__)
  }
  
  module.hot.accept("./JoinPublicationExistingUser.vue.js?vue&type=template&id=1b36ddf8!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=template&id=1b36ddf8", () => {
    api.rerender('1b36ddf8', render)
  })

}


export default __exports__